import React from 'react';
import { useApiGet, useApiLoading } from 'react-reqq-lite';
import { removeEmpty } from 'modules/common/helper';
import * as c from './constants';
import * as actions from './actions';

export const useChangePassword = () => {
  const isApiLoading = useApiLoading(c.CHANGE_PASSWORD, 'post');
  const changePassword = React.useCallback((payload, callback) => {
    actions.changePassword(payload, callback);
  }, []);
  return [isApiLoading, changePassword];
};

export const useCheckToken = (params) => {
  const isApiLoading = useApiLoading(c.CHECK_TOKEN, 'get');
  const checkToken = useApiGet(`${c.CHECK_TOKEN}.data`, {});

  React.useEffect(() => {
    actions.checkToken(removeEmpty(params));
  }, [params]);

  return [isApiLoading, checkToken];
};
